import {
  withTypes,
  Field,
} from 'react-final-form';
import classNames from 'classnames';
import { t } from 'ttag';

import { useRegion } from '@hook/useRegion';
import { required } from '@utils/validators';
import { Modal, ModalProps } from '@ui/Modal';
import { Title } from '@ui/Title';
import { Input } from '@ui/Input';
import { FormError } from '@ui/FormError';
import { Button } from '@ui/Button';

import s from './PrepaymentEditFormModal.sss';

export interface FormData {
  prepayment: number,
}

interface Props extends ModalProps {
  prepayment: number,
  isSubmitting?: boolean,
  onSubmit: (data: FormData) => void,
}

export const PrepaymentEditFormModal: React.FC<Props> = ({
  className,
  prepayment,
  isSubmitting,
  onSubmit,
  onRequestClose,
  ...props
}) => {
  const { currencyName } = useRegion();
  const { Form } = withTypes<FormData>();

  return (
    (
      <Modal
        className={classNames(s.modal, className)}
        onRequestClose={onRequestClose}
        {...props}
      >
        <Title
          type="h3"
          bold={false}
          className={s.title}
        >
          {t`Післяплата`}
        </Title>
        <p className={s.description}>
          {t`Вкажіть суму передплати, якщо ви відправляєте по післяплаті з мінімальною передплатою.`}
        </p>
        <p className={s.description}>
          {t`ТТН сформується за вирахуванням суми передплати`}
        </p>
        <Form
          onSubmit={onSubmit}
          initialValues={{
            prepayment: Number(prepayment) || 0,
          }}
          render={({ handleSubmit, submitting, submitError }) => (
            <form
              className={s.form}
              onSubmit={handleSubmit}
            >
              <Field
                type="number"
                name="prepayment"
                validate={required}
              >
                {({ input, meta }) => (
                  <>
                    <Input
                      {...input}
                      className={s.input}
                      label={t`Сума, ${currencyName}`}
                      value={input.value || ''}
                      disabled={submitting}
                      invalid={(meta.touched && meta.error) || meta.submitError}
                      error={(meta.touched && meta.error) || meta.submitError}
                    />

                    {submitError && (
                    <FormError>
                      {submitError}
                    </FormError>
                    )}
                  </>
                )}
              </Field>

              <div className={s.footer}>
                <Button
                  type="button"
                  theme="secondary"
                  className={s.button}
                  onClick={onRequestClose}
                >
                  {t`Відміна`}
                </Button>
                <Button
                  className={s.button}
                  type="submit"
                  disabled={isSubmitting}
                >
                  {t`Застосувати`}
                </Button>
              </div>
            </form>
          )}
        />
      </Modal>
    )
  );
};
